import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error: err } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (err) { setError(err.message); return; }
    if (data.user) onLogin(data.user);
  };

  return (
    <div style={styles.page}>
      <div style={styles.blob1} />
      <div style={styles.blob2} />
      <div style={styles.blob3} />

      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoCircle}>
            <img src="/assets/img/logo.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%', backgroundColor: "black" }} />
          </div>
          <h1 style={styles.brand}>Baby Twinkles Photography</h1>
          <p style={styles.tagline}>Admin Portal</p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          {error && (
            <div style={styles.errorBox}>
              <span>⚠ {error}</span>
            </div>
          )}

          <div style={styles.fieldWrap}>
            <label style={styles.label}>Email Address</label>
            <div style={styles.inputGroup}>
              <FiMail style={styles.inputIcon} />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="admin@gmail.com"
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.fieldWrap}>
            <label style={styles.label}>Password</label>
            <div style={styles.inputGroup}>
              <FiLock style={styles.inputIcon} />
              <input
                type={showPwd ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                style={{ ...styles.input, paddingRight: '44px' }}
              />
              <button
                type="button"
                onClick={() => setShowPwd(p => !p)}
                style={styles.eyeBtn}
              >
                {showPwd ? <FiEyeOff size={16} /> : <FiEye size={16} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={styles.submitBtn}
            onMouseEnter={e => !loading && (e.target.style.transform = 'translateY(-2px)')}
            onMouseLeave={e => (e.target.style.transform = 'translateY(0)')}
          >
            {loading ? (
              <span style={styles.spinner} />
            ) : (
              'Sign In to Dashboard'
            )}
          </button>
        </form>

        <div style={styles.backToHome}>
          <a href="/" style={styles.backLink}>
            ← Back to Home
          </a>
        </div>

        <p style={styles.footer}>
          © 2026 Baby Twinkles Photography | Design By{" "}
          <a
            href="https://webdigihr.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "800",
              color: "white",
            }}
          >
            WebDigiHr
          </a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  blob1: {
    position: 'absolute', width: 400, height: 400,
    background: 'radial-gradient(circle, rgba(139,92,246,0.3), transparent 70%)',
    top: '-100px', left: '-100px', borderRadius: '50%',
    animation: 'float 8s ease-in-out infinite',
  },
  blob2: {
    position: 'absolute', width: 300, height: 300,
    background: 'radial-gradient(circle, rgba(236,72,153,0.25), transparent 70%)',
    bottom: '-80px', right: '-80px', borderRadius: '50%',
    animation: 'float 10s ease-in-out infinite reverse',
  },
  blob3: {
    position: 'absolute', width: 200, height: 200,
    background: 'radial-gradient(circle, rgba(59,130,246,0.2), transparent 70%)',
    top: '50%', right: '10%', borderRadius: '50%',
    animation: 'float 12s ease-in-out infinite',
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 24,
    padding: '20px',
    width: '100%',
    maxWidth: 420,
    boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
    position: 'relative',
    zIndex: 10,
  },
  logoWrap: {
    textAlign: 'center',
    marginBottom: 26,
  },
  logoCircle: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #7c3aed, #ec4899)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
    boxShadow: '0 8px 32px rgba(124,58,237,0.4)',
  },
  brand: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 700,
    margin: '0 0 6px',
    letterSpacing: '-0.5px',
  },
  tagline: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 13,
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  errorBox: {
    background: 'rgba(239,68,68,0.15)',
    border: '1px solid rgba(239,68,68,0.4)',
    borderRadius: 10,
    padding: '10px 14px',
    color: '#fca5a5',
    fontSize: 13,
  },
  fieldWrap: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { color: 'white', fontSize: 13, fontWeight: 500 },
  inputGroup: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputIcon: {
    position: 'absolute', left: 14, color: 'white',
    pointerEvents: 'none', fontSize: 16,
  },
  input: {
    width: '100%',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 12,
    padding: '13px 14px 13px 42px',
    color: '#fff',
    fontSize: 14,
    outline: 'none',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  },
  eyeBtn: {
    position: 'absolute', right: 14,
    background: 'none', border: 'none',
    color: 'rgba(255,255,255,0.4)',
    cursor: 'pointer', padding: 0, display: 'flex',
  },
  submitBtn: {
    background: 'linear-gradient(135deg, #7c3aed, #ec4899)',
    color: '#fff',
    border: 'none',
    borderRadius: 12,
    padding: '14px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 8px 24px rgba(124,58,237,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
  },
  spinner: {
    width: 20, height: 20,
    border: '2px solid rgba(255,255,255,0.3)',
    borderTopColor: '#fff',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
    display: 'inline-block',
  },
  footer: {
    textAlign: 'center',
    fontSize: 12,
    marginTop: 32,
    color: 'white',
    marginBottom: 0,
  },
  backToHome: {
    textAlign: 'center',
    marginTop: 20,
  },
  backLink: {
    color: 'white',
    fontSize: 13,
    fontWeight: "bold",
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
};

export default AdminLogin;
